import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { ButtonBase, Typography } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

interface Props {
  text: string;
  disabled?: boolean;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  capitalize?: boolean;
  backArrow?: boolean;
  margin?: string;
  marginTop?: string;
  marginRight?: string;
  marginBottom?: string;
  marginLeft?: string;

  action(): void;
}

const PaiActionText: React.FC<Props> = ({
  text,
  disabled,
  size = 'md',
  capitalize,
  backArrow,
  margin,
  marginTop,
  marginRight,
  marginBottom,
  marginLeft,
  action,
}) => {
  const { classes } = useStyles({ capitalize, size });

  return (
    <ButtonBase className={classes.button} onClick={action} style={{ margin, marginTop, marginRight, marginBottom, marginLeft }} disabled={disabled}>
      {backArrow ? <ArrowBackIcon className={classes.icon} /> : <ArrowForwardIcon className={classes.icon} />}
      <Typography className={classes.text}>{text}</Typography>
    </ButtonBase>
  );
};

const useStyles = makeStyles<{ capitalize?: boolean; size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' }>()((theme, { capitalize, size }) => ({
  button: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    fontSize:
      size === 'xs'
        ? theme.typography.pxToRem(16)
        : size === 'sm'
        ? theme.typography.pxToRem(18)
        : size === 'md'
        ? theme.typography.pxToRem(20)
        : size === 'lg'
        ? theme.typography.pxToRem(24)
        : size === 'xl'
        ? theme.typography.pxToRem(28)
        : theme.typography.pxToRem(20),
    color: theme.palette.primary.main,
    marginRight: '16px',
  },
  text: {
    fontSize:
      size === 'xs'
        ? theme.typography.pxToRem(10)
        : size === 'sm'
        ? theme.typography.pxToRem(12)
        : size === 'md'
        ? theme.typography.pxToRem(13)
        : size === 'lg'
        ? theme.typography.pxToRem(15)
        : size === 'xl'
        ? theme.typography.pxToRem(18)
        : theme.typography.pxToRem(13),
    fontWeight: 'bold',
    textDecoration: 'underline',
    textTransform: capitalize ? 'capitalize' : 'none',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
}));

export default PaiActionText;
